<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeFilter" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <div class="row align-items-end pt-2">
              <filter-component
                @filter="handleFilter"
                @onChangeFilters="handleFilterChange"
                @showHideLoading="showHideLoading"
                :filterOfZones="true"
                :filterOfSubZones="true"
                :filterOfLots="false"
                :classFarms="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classZones="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :classSubZones="`col-12 col-md-6 col-lg-4 col-xl-4`"
                :isRequiredZones="true"
                :isRequiredSubZones="true"
                :isRequiredFarms="true"
              ></filter-component>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div
          v-if="hasData"
          class="row mx-1 d-flex flex-wrap justify-content-between align-items-center"
        >
          <div
            v-for="(chart, index) in columnChart"
            :key="index"
            :class="cardClass(index)"
          >
            <card class="w-100">
              <div class="row">
                <div class="col-12">
                  <highcharts :options="chart" />
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
      <div v-if="isIndex()">
        <div v-if="hasData">
          <card
            class="custom-shadow-card-header"
            :title="$t('sigatoka.sigatoka_ranking_report')"
          >
            <el-collapse v-model="activeFarms" @change="handleCollapse">
              <el-collapse-item
                v-for="farm in farms"
                :key="farm"
                :title="farm"
                :name="farm"
              >
                <div class="row w-100 pl-3 pr-3">
                  <div class="col-12 p-0">
                    <el-collapse
                      v-model="activeAgeTables"
                      class="age-report-collapse"
                    >
                      <el-collapse-item
                        v-for="ageTable in ageTablesByFarm(farm)"
                        :key="farm + '-age-' + ageTable.age"
                        :name="farm + '-age-' + ageTable.age"
                      >
                        <template slot="title">
                          <div class="w-100 d-flex align-items-center">
                            <strong class="ml-3">
                              {{ ageTable.label }}
                            </strong>
                          </div>
                        </template>
                        <div class="table-responsive age-table-wrapper">
                          <table
                            class="table table-striped table-bordered mb-0 w-100"
                          >
                            <thead class="cusmtom-thead-color">
                              <tr class="cusmtom-thead-color">
                                <th
                                  rowspan="2"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('common_words.date') }}
                                </th>
                                <th
                                  rowspan="2"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('sigatoka.total_functional_leaves') }}
                                </th>
                                <th
                                  rowspan="2"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('sigatoka.yls') }}
                                </th>
                                <th
                                  v-if="ageTable.includeYli"
                                  rowspan="2"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('sigatoka.yli') }}
                                </th>
                                <th
                                  v-if="ageTable.hasInfectionPicture"
                                  colspan="5"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('sigatoka.infection_picture') }}
                                </th>
                              </tr>
                              <tr
                                v-if="ageTable.hasInfectionPicture"
                                class="cusmtom-thead-color"
                              >
                                <th
                                  v-for="grade in [0, 1, 2, 3, 4]"
                                  :key="
                                    farm +
                                    '-grade-' +
                                    ageTable.age +
                                    '-' +
                                    grade
                                  "
                                  class="text-center p-3 custom-header-label infection-column"
                                >
                                  {{ grade }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="row in ageTable.rows" :key="row.key">
                                <td class="text-center">
                                  {{ row.date }}
                                </td>
                                <td class="text-center">
                                  {{ row.total_leaves }}
                                </td>
                                <td class="text-center">
                                  {{ row.yls }}
                                </td>
                                <td
                                  v-if="ageTable.includeYli"
                                  class="text-center"
                                >
                                  {{ row.yli }}
                                </td>
                                <template v-if="ageTable.hasInfectionPicture">
                                  <td
                                    v-for="grade in [0, 1, 2, 3, 4]"
                                    :key="
                                      farm +
                                      '-infection-' +
                                      ageTable.age +
                                      '-' +
                                      row.key +
                                      '-' +
                                      grade
                                    "
                                    class="text-center infection-column"
                                  >
                                    {{
                                      row.infection_picture &&
                                      row.infection_picture[grade] !==
                                        undefined &&
                                      row.infection_picture[grade] !== null
                                        ? row.infection_picture[grade]
                                        : '-'
                                    }}
                                  </td>
                                </template>
                              </tr>
                              <tr v-if="ageTable.rows.length === 0">
                                <td
                                  :colspan="
                                    3 +
                                    (ageTable.includeYli ? 1 : 0) +
                                    (ageTable.hasInfectionPicture ? 5 : 0)
                                  "
                                  class="text-center p-4"
                                >
                                  {{ $t('common_words.unavailable_data') }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                    <el-collapse
                      v-if="showYoungPlants(farm)"
                      v-model="activeAgeTables"
                      class="age-report-collapse mt-3"
                    >
                      <el-collapse-item :name="farm + '-young-plants'">
                        <template slot="title">
                          <div class="w-100 d-flex align-items-center">
                            <strong class="ml-3">
                              {{ $t('sigatoka.young_plants') }}
                            </strong>
                          </div>
                        </template>
                        <div class="table-responsive age-table-wrapper">
                          <table
                            class="table table-striped table-bordered mb-0 w-100"
                          >
                            <thead class="cusmtom-thead-color">
                              <tr>
                                <th class="text-center p-3 custom-header-label">
                                  {{ $t('common_words.date') }}
                                </th>
                                <th class="text-center p-3 custom-header-label">
                                  {{ $t('sigatoka.total_functional_leaves') }}
                                </th>
                                <th class="text-center p-3 custom-header-label">
                                  {{ $t('sigatoka.ref') }}
                                </th>
                                <th
                                  v-for="leaf in youngData(farm)"
                                  :key="farm + '-leaf-' + leaf"
                                  class="text-center p-3 custom-header-label"
                                >
                                  {{ $t('sigatoka.leaf') }} {{ leaf }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="row in youngPlantRowsByFarm(farm)"
                                :key="row.key"
                              >
                                <td class="text-center">
                                  {{ row.date }}
                                </td>
                                <td class="text-center">
                                  {{ row.functional_leaf }}
                                </td>
                                <td class="text-center">
                                  {{ row.ref }}
                                </td>
                                <td
                                  v-for="leaf in youngData(farm)"
                                  :key="
                                    farm +
                                    '-young-value-' +
                                    row.key +
                                    '-' +
                                    leaf
                                  "
                                  class="text-center"
                                >
                                  {{
                                    row.leaves &&
                                    row.leaves[leaf] !== undefined &&
                                    row.leaves[leaf] !== null
                                      ? row.leaves[leaf]
                                      : '-'
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
            <export-tables class="mb-3" :pdf="pdf" :xls="xls" />
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { Chart } from 'highcharts-vue';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import { getDateToday } from 'src/util/Util';
import MixinCharts from 'src/util/mixinCharts';
import MixinMasters from 'src/util/mixinMasters';
import Filter from 'src/components/Filter/Filters.vue';
import MixinPermissions from 'src/util/mixinPermissions';
import ExportTables from 'src/components/Tables/ExportTables.vue';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  mixins: [
    MixinMenu,
    MixinCharts,
    MixinMasters,
    MixinPermissions,
    MixinValidations,
  ],
  components: {
    [ExportTables.name]: ExportTables,
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      data: {},
      table: [],
      hasData: false,
      activeFarms: [],
      activeAgeTables: [],
      columnChart: [],
      valueCollapse: null,
      activeFilter: ['filter'],
    };
  },
  computed: {
    dateToday() {
      return getDateToday();
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    farms() {
      if (!this.table || !Object.keys(this.table).length) return [];
      return Object.keys(this.table);
    },
    pdf() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_ranking_report')}_${
          this.dateToday
        }.pdf`,
        route: 'sigatoka/ranking/pdf',
        paramMethod: 'POST',
        plusData: {
          data: this.data,
        },
      };
    },
    xls() {
      return {
        filename: `${i18n.t('sigatoka.sigatoka_ranking_report')}_${
          this.dateToday
        }.xlsx`,
        route: 'sigatoka/ranking/excel',
        paramMethod: 'POST',
        plusData: {
          data: this.data,
        },
      };
    },
  },
  methods: {
    handleFilterChange() {
      this.hasData = false;
    },
    handleFilter(data) {
      this.hasData = false;
      this.dataFilter = { ...data };
      this.data = this.dataFilter;
      this.getData();
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    cardClass(index) {
      if (this.columnChart.length > 4) {
        if (index > 1) return 'col-12 col-md-12 col-lg-4';
        if (index === 4) return 'col-12 col-md-12 col-lg-4';
      }
      return 'col-12 col-md-12 col-lg-6';
    },
    youngData(farm) {
      if (!this.table || !this.table[farm]) return [];
      const leaves = new Set();
      this.table[farm].forEach((item) => {
        if (!item.youngPlants || !item.youngPlants.leaves) return;
        Object.keys(item.youngPlants.leaves).forEach((leaf) => {
          leaves.add(Number(leaf));
        });
      });

      return Array.from(leaves).sort((a, b) => a - b);
    },
    ageTablesByFarm(farm) {
      if (!this.table[farm] || !this.table[farm].length) return [];
      const columns = this.ageColumnsByFarm(farm);

      return columns.map((column) => {
        const rows = [];
        this.table[farm].forEach((item) => {
          if (!item.totals) return;
          const found = item.totals.find(
            (total) => Number(total.age) === Number(column.age)
          );
          if (!found) return;
          const metrics = found.metrics || {};
          rows.push({
            key: farm + '-' + item.id + '-' + column.age + '-' + item.date,
            date: item.date,
            total_leaves:
              metrics.total_leaves !== undefined ? metrics.total_leaves : 0,
            yls: metrics.yls !== undefined ? metrics.yls : 0,
            yli: metrics.yli !== undefined ? metrics.yli : '-',
            infection_picture: found.infection_picture || null,
          });
        });
        const includeYli = column.metrics && column.metrics.includes('yli');
        const hasInfectionPicture =
          column.infection_picture === true ||
          this.table[farm].some((item) => {
            if (!item.totals) return false;
            const found = item.totals.find(
              (total) => Number(total.age) === Number(column.age)
            );

            return !!(found && found.infection_picture);
          });

        return {
          age: column.age,
          label: column.label,
          includeYli,
          hasInfectionPicture,
          rows,
        };
      });
    },
    ageColumnsByFarm(farm) {
      if (!this.table[farm] || !this.table[farm].length) return [];
      const columns = {};
      this.table[farm].forEach((item) => {
        if (!item.ageColumns) return;
        item.ageColumns.forEach((column) => {
          const age = Number(column.age);
          if (!columns[age]) {
            columns[age] = {
              ...column,
              age,
              metrics: [...(column.metrics || [])],
              infection_picture: column.infection_picture === true,
            };

            return;
          }
          (column.metrics || []).forEach((metric) => {
            if (!columns[age].metrics.includes(metric))
              columns[age].metrics.push(metric);
          });
          if (column.infection_picture === true)
            columns[age].infection_picture = true;
        });
      });

      return Object.values(columns).sort((a, b) => a.age - b.age);
    },
    youngPlantRowsByFarm(farm) {
      if (!this.table[farm]) return [];

      return this.table[farm]
        .filter((item) => item.youngPlants)
        .map((item) => {
          return {
            key: farm + '-young-' + item.id + '-' + item.date,
            date: item.date,
            functional_leaf:
              item.youngPlants.functional_leaf !== undefined
                ? item.youngPlants.functional_leaf
                : 0,
            ref: item.youngPlants.ref !== undefined ? item.youngPlants.ref : 0,
            leaves: item.youngPlants.leaves || {},
          };
        });
    },
    showYoungPlants(farm) {
      if (!this.table || !this.table[farm] || !this.table[farm].length)
        return false;

      return this.table[farm].some((item) => !!item.youngPlants);
    },

    async getData() {
      if (this.isIndex()) this.setData(await this.getReport());
      else this.showHideLoading();
      this.showHideLoading();
    },
    async getReport() {
      this.showHideLoading(true);
      const data = this.dataFilter;
      data.route = 'sigatoka/ranking/filterdata';
      const [responseReport] = await Promise.all([
        Axios.postMasters(data),
      ]).catch((error) => {
        this.showHideLoading();
        this.showMessageErrors(error);
      });

      return responseReport.data.data;
    },
    setData(response) {
      if (!response.table)
        SweetAlert.warning(i18n.t('common_words.unavailable_data'));
      else {
        this.table = response.table;
        this.columnChart = response.columnChart.map((chart) =>
          this.columns(chart)
        );
        this.hasData = true;
        this.$nextTick(() => {
          this.activeFarms = Object.keys(this.table);
        });
      }
      this.showHideLoading();
    },
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
</style>
